// src/components/footer.jsx
import React from "react";
// import { FiPhone } from "react-icons/fi"; // if using react-icons

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <h4>ROOFTECH</h4>
          <p>
            End-to-end solutions for industrial roofing, interiors,
            and controlled environments.
          </p>
        </div>

        <div>
          <h5>Contact</h5>
          <p>135, Vihav Trade Center, Near Waves Club, Canal road, Bhayli, Vadodara - 391410, Gujarat</p>
          <p>
            {/* Phone icon + clickable tel: link */}
            {/* <FiPhone style={{ marginRight: "0.4rem" }} /> */}
            <a href="tel:+919426948038" className="footer-phone-link">
              +91-9426948038
            </a>
          </p>
          <p>
            ✉️{" "}
            <a href="mailto:rooftechhelp@gmail.com">
              rooftechhelp@gmail.com
            </a>
          </p>
          <p>
            GST Number :-  24AKXPP3375Q1Z1
          </p>
        </div>

        <div>
          <h5>Office Hours</h5>
          <p>Mon – Sat · 9:00 AM – 6:00 PM</p>
          <p>Closed on Sundays and public holidays.</p>
        </div>
      </div>

      <div className="footer-bottom">
        © 2025 ROOFTECH. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
